import balancer from './assets/balancer.png';
import ftm from './assets/ftm.png';
import polygon from './assets/polygon.png';
import qi from './assets/qi.png';
import scream from './assets/scream.png';
import socket from './assets/socket.png';
import spooky from './assets/spooky.png';
import tarot from './assets/tarot.png';
import universe from './assets/universe.png';
import sphere from './assets/sphere.png';
import ovix from './assets/ovix.png';

export const partners = {
    'Polygon': polygon,
    'QiDao': qi,
    'Tarot': tarot,
    'Scream': scream,
    'Balancer': balancer,
    'Universe': universe,
    'SpookySwap': spooky,
    'FTM Alerts': ftm,
    'Sphere Finance': sphere,
    'Socket': socket,
    '0VIX': ovix,
};
